var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon-section-text",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14.238",
        height: "16.058",
        viewBox: "0 0 14.238 16.058"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M14.238 3.57V0H0v3.57a.75.75 0 001.5 0V1.501h4.869V14.56h-1.56a.75.75 0 000 1.5H9.43a.75.75 0 000-1.5H7.869V1.501h4.869v2.071a.75.75 0 001.5 0z",
          fill: "#939393"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }